<containerless></containerless>

<button
  id="apply-now"
  class="button"
  click.trigger="processPayment()"
  disabled.bind="isProcessing"
>
  Apply Now
</button>
